export enum Routes {
  LOGIN = "/app",
  SOLICITUDES = "/app/solicitudes",
}
